import React from "react";
import { HydroPopupContainer } from "./popupTableHelper";
import ReactDOMServer from "react-dom/server";

export const getInfoHydro = async (feature) => {
  let attributes,
    content = document.createElement('div');
  attributes = feature.graphic.attributes;
  const tableElements = {
    'Date de fin': attributes['RealEndDate'],
    Nombre: attributes['number'] ? attributes['number'] : 'N/A',
  };

  content.innerHTML = ReactDOMServer.renderToString(
    <HydroPopupContainer
      title='Point noir'
      titleValue={attributes['Reference']}
      tableElements={tableElements}
    />
  );
  return content;
}